/*@ngInject*/
module.exports = function roadElementsService($http) {
    this.getRoadElementsSearch = function(filter) {
        return $http.post('roadElements/getRoadElementsBySearch/', {filter});
    };

    this.getFilterAmountsByCounty = function(county) {
        return $http.post('roadElements/getFilterAmountsByCounty/', {county});
    };

    this.getRoadElementDataById = function (versionId) {
        return $http.get('roadElements/getRoadElementDataById/' + versionId);
    };

    this.getPreviewId = function () {
        return $http.get('roadElements/getPreviewId/');
    };

    this.akisDetailsById = function(id) {
        return $http.get('roadElements/akisDetailsById/' + id);
    };

    this.opisDetailsById = function(id) {
        return $http.get('roadElements/opisDetailsById/' + id);
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/services/road-elements.service.js
 **/